export const prodata = [
  {
    id: 1,
    title: "The Venue Concert Ticket Booking",
    tech: ["ReactJS", "NodeJS", "ExpressJS", "MongoDB"],
    descp:
      "Built on the MERN stack, the web app enables smooth ticket purchases via PayPal. Robust backend APIs manage routes, interact with MongoDB for secure data storage, and leverage cookies for enhanced user experience through efficient session management. ",
    img: "./pro1.png",
    linktocode: "https://github.com/ItsRitik/The-Venue-Concert-Ticket-Booking",
    linktolive: "https://the-venue-concert-tickets-a7a8057d60fb.herokuapp.com/",
  },
  {
    id: 2,
    title: "Travel Advisor",
    tech: ["NextJS", "Rapid-API", "Axios"],
    descp:
      "This is a Travel Advisor App to explore Restaurants, Hotels and Tourist Attractions anywhere in the world.",
    img: "./pro2.png",
    linktocode: "https://github.com/ItsRitik/Travel-Advisor",
    linktolive: "",
  },
  {
    id: 3,
    title: "Gesture Based Cursor Control System",
    tech: ["Python", "OpenCV", "Pandas"],
    descp:
      "Developed a webcam-based gesture recognition system for cursor control and function execution, seamlessly integrating the PyAutoGUI library. The system, calibrated to recognize color-based ribbons for gesture movements, achieves an accuracy rate of 89.5%, providing an intuitive and efficient cursor control experience with automated Python scripting functionality.",
    img: "./Demo.mp4",
    linktocode:
      "https://github.com/ItsRitik/Gesture-Based-cursor-control-system",
    linktolive: "",
  },
  {
    id: 4,
    title: "Advise Generator",
    tech: ["ReactJS", "Javascript", "Axios"],
    descp:
      "This is a simple React application to generate random life advices.",
    img: "./pro4.png",
    linktocode: "https://github.com/fabian-hiller/pace-flight-planner",
    linktolive: "https://advice-generator-psi-ivory.vercel.app/",
  },
];
